<template>
  <OppleAuth code="ReadArea,ControlArea" :force-show="noAuth || $store.state.isPassPermission">
    <div class="scence_box clearfix scence_box_action">
      <!-- 国内需要校验 --->
      <!-- <div v-if="noAuthControl" class="areacotrol_masker" /> -->
      <!-- <div
        v-for="(tem, index) in renderList"
        :key="index"
        class="device_div_action"
        :class="{ device_div_collapse: tem.Values[0].ValueType === 'UIControl_Scene_Baoli' }"
      >
        <div>
          <div v-if="tem.ControlName && tem.ControlName.trim() !== ''" class="ControlName">
            {{ tem.ControlName }}
          </div>
          <control-item
            :checkeddata="checkeddata"
            :show-button="isdevice"
            :action-info="tem"
            :show-check-box="showCheckBox"
            :is-i-f-t-t="isIFTT"
            @changeCheckBox="checkRadioAction(tem)"
            @button-action="doIsjoined"
            @do-call-action-middle="doChange"
          />
        </div>
      </div> -->
      <div
        v-for="(group, gIndex) in renderList"
        :key="gIndex"
        class="group_box"
        :class="{ flex_mode: isShowFlex }"
      >
        <div class="group_title">
          {{ group.groupName }}
        </div>
        <div v-for="(tem, index) in group.actions" :key="index" class="device_div_action">
          <control-item
            :checkeddata="checkeddata"
            :action-info="tem"
            :show-button="isdevice"
            :show-check-box="showCheckBox"
            :is-i-f-t-t="isIFTT"
            @changeCheckBox="checkRadioAction(tem)"
            @button-action="doIsjoined"
            @do-call-action-middle="doChange"
          />
        </div>
      </div>

      <slot />
    </div>
  </OppleAuth>
</template>

<script>
import { OpenLight, CloseLight, AdjustBright, AdjustTemperature, AdjustColor, StepDimming, StepCCT, LightMode, GetCallScene } from '@/axios/IArea.js'
import { IsExistAreaAndAddressMap } from '@/axios/IDevice.js'
import { alerterror, alertsuccess } from '@/assets/js/common.js'
import ControlItem from '@/components/common/controlItem'
import { getFillOrderFn } from '@/page/control-ts/scene/sceneHandle/indexFns'
import { transLightToValue } from '@/utils/actionsHandler'
import { GetThirdPartSceneList } from '@/axios/IDevice.js'
import { isExistPermission } from '@/components/OppleAuth/index'
import { ActionVo } from '@utils/actionsHandler'
import i18n from '@/i18n/i18n'

let getSortOrderValue = () => null
let minValue
let minColorWarm
let maxColorWarm

const getList = ($t, isdevice) => [
  // {
  //   IsShow: true,
  //   ischeck: !isdevice,
  //   MsgType: '0x03110000',
  //   ShowMode: -1,
  //   Desc: $t('sceneCard.lightSwitch'),
  //   ControlName: '总控',
  //   ChannelId: 65535,
  //   Values: [
  //     {
  //       KeyId: 1,
  //       ValueType: 'UIControl_Switch',
  //       Name: $t('sceneCard.lightSwitch'),
  //       DefaultValue: 0,
  //       Min: 0,
  //       Max: 1,
  //       EnumValue: [
  //         { Name: $t('sceneCard.openLight'), Value: 1 },
  //         { Name: $t('sceneCard.closeLight'), Value: 0 },
  //       ],
  //       IsShow: true,
  //       Type: '0x0207',
  //     },
  //   ],
  //   ControlType: 0,
  // },
  // {
  //   IsShow: true,
  //   ischeck: !isdevice,
  //   MsgType: '0x03130000',
  //   ShowMode: -1,
  //   Desc: $t('sceneCard.light'),
  //   ChannelId: 65535,
  //   Values: [
  //     {
  //       KeyId: 1,
  //       ValueType: 'UIControl_Bright',
  //       Name: $t('sceneCard.light'),
  //       DefaultValue: 100,
  //       Min: minValue,
  //       Max: 100,
  //       EnumValue: [],
  //       IsShow: true,
  //       Type: '0x0300',
  //     },
  //   ],
  //   ControlType: 4,
  // },
  ...Array.from({ length: 4 }).flatMap((_, i) => [
    {
      IsShow: true,
      ischeck: !isdevice,
      MsgType: '0x03110000',
      ShowMode: -1,
      Desc: $t('sceneCard.lightSwitch'),
      ChannelId: i + 1,
      ControlName: `${i18n.t('scene.partialControl')}${i + 1}`,
      Values: [
        {
          KeyId: 1,
          ValueType: 'UIControl_Switch',
          Name: $t('sceneCard.lightSwitch'),
          DefaultValue: 0,
          Min: 0,
          Max: 1,
          EnumValue: [
            { Name: $t('sceneCard.openLight'), Value: 1 },
            { Name: $t('sceneCard.closeLight'), Value: 0 },
          ],
          IsShow: true,
          Type: '0x0207',
        },
      ],
      ControlType: 0,
    },
    {
      IsShow: true,
      ischeck: !isdevice,
      MsgType: '0x03130000',
      ShowMode: -1,
      Desc: $t('sceneCard.light'),
      ChannelId: i + 1,
      Values: [
        {
          KeyId: 1,
          ValueType: 'UIControl_Bright',
          Name: $t('sceneCard.light'),
          DefaultValue: 100,
          Min: minValue,
          Max: 100,
          EnumValue: [],
          IsShow: true,
          Type: '0x0300',
        },
      ],
      ControlType: 4,
    },
  ]),
]
export default {
  components: {
    ControlItem,
  },
  props: {
    highid: {
      type: Number,
      default: -1,
    },
    isdevice: {
      type: Boolean,
      default: false,
    },
    checkeddata: {
      type: Array,
      default() {
        return []
      },
    },
    noAuth: {
      type: Boolean,
      default: false,
    },
    isExistGsDevice: {
      type: Boolean,
      default: false,
    },
    //自动化利用传进来的列表渲染，设备区控自己组件内计算渲染
    propsList: {
      type: Array,
      default: () => [],
    },

    areaControlType: {
      type: String,
      default: 'IFttt',
    },

    showCheckBox: {
      type: Boolean,
      default: false,
    },
    isIFTT: {
      type: Boolean,
      default: false,
    },
    isShowFlex: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noAuthControl: false,
      list: [],
      color: 'rgb(0, 0, 0)', // 颜色
      doChangeTime: null, // 延时下发规避频繁
      oppleSwitch: [
        {
          isCollapse: true,
          ischeck: !this.isdevice,
          Desc: this.$t('sceneCard.lightSwitch'),
          MsgType: '0x02',
          orderType: '0x03110000',
          Values: [
            {
              KeyId: 1,
              IsShow: true,
              ValueType: 'UIControl_Switch',
              DefaultValue: 0,
              Name: this.$t('sceneCard.lightSwitch'),
            },
          ],
        },
      ],
      baoLiSwitch: [
        {
          isCollapse: true,
          ischeck: !this.isdevice,
          Desc: this.$t('sceneCard.workStatus'),
          MsgType: '0x06',
          orderType: '0x03110000',
          Values: [
            {
              KeyId: 1,
              IsShow: true,
              ValueType: 'UIControl_Radio_Baoli',
              DefaultValue: 0,
              EnumValue: [
                { Name: this.$t('sceneCard.sensor'), Value: 0 },
                { Name: this.$t('sceneCard.alwaysOpen'), Value: 1 },
                { Name: this.$t('sceneCard.alwaysClose'), Value: 2 },
                { Name: this.$t('sceneCard.sleep'), Value: 3 },
              ],
              Name: this.$t('sceneCard.workStatus'),
            },
          ],
        },
        {
          isCollapse: true,
          ischeck: !this.isdevice,
          ChannelId: 0,
          CnDesc: null,
          Desc: this.$t('sceneCard.sceneNumber'),
          MsgType: '0x05880000',
          orderType: '0x05880000',
          Values: [
            {
              IsShow: true,
              KeyId: 1,
              ValueType: 'UIControl_Scene_Baoli',
              DefaultValue: 0,
              EnumValue: [],
              Name: this.$t('sceneCard.sceneNumber'),
            },
          ],
        },
      ],
    }
  },
  computed: {
    appDocumentWidth() {
      return this.$store.state.appDocumentWidth
    },
    renderList() {
      if (this.areaControlType === 'IFttt') {
        return this.normalizeList(this.propsList)
      } else {
        return this.normalizeList(this.list)
      }
    },
  },
  watch: {
    appDocumentWidth(value, oldVal) {
      if (oldVal === value || !this.isdevice) return
      getSortOrderValue = getFillOrderFn(value)
      this.fillList()
    },
  },
  mounted() {
    getSortOrderValue = getFillOrderFn(this.appDocumentWidth)
    this.fillList()

    if (this.noAuth) return

    this.noAuthControl = !isExistPermission('ControlArea', this.$store.state.isPassPermission)

    //this.handleAction()
  },
  beforeDestroy() {
    (this.renderList || []).forEach(group => {
      group.actions.forEach(model => {
        if (model.Values?.[0]?.ValueType === 'UIControl_Bright') {
          model.Values[0].Max = 255
        }
      })
    })
  },

  methods: {
    normalizeList(list) {
      if (list.length === 0) return
      const groups = []

      this.handleAction(list)

      list.forEach(item => {
        // 根据 ChannelId 判断分组 (也可以用 ControlName / MsgType 规则来分)
        const groupName = item.ChannelId === 65535 ? this.$t('scene.masterControl'): `${this.$t('scene.partialControl')}${item.ChannelId}`

        // 查找分组是否已经存在
        let group = groups.find(g => g.groupName === groupName)
        if (!group) {
          group = { groupName, actions: [] }
          groups.push(group)
        }

        // ⚠️ 直接 push 原始对象，保持引用关系
        group.actions.push(item)
      })

      return groups
    },

    checkRadioAction(item) {
      item.ischeck = !item.ischeck
    },
    //处理下能力
    handleAction(list) {
      list.forEach(model => {
        //model.ischeck = true
        if (model.Values[0].ValueType === 'UIControl_Bright') {
          model.Values[0].Max = 100
        }
      })
    },
    async addSceneOnList() {
      let tempArr = []
      if (this.isExistGsDevice) {
        try {
          const { StatusCode, Result } = await GetThirdPartSceneList({ BrandId: 1024 })
          if (StatusCode == this.$store.state.rightStatusCode) {
            tempArr = getList(this.$t, this.isdevice).concat(this.baoLiSwitch)

            tempArr = tempArr.map(item => {
              if (item.Values[0].ValueType == 'UIControl_Scene_Baoli') {
                return {
                  ...item,
                  Values: [{ ...item.Values[0], EnumValue: Result || [] }],
                }
              }
              return item
            })
            this.list = tempArr
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        tempArr = getList(this.$t, this.isdevice)
        this.list = tempArr
      }

      console.log('....addSceneOnList', this.list)
    },
    fillList() {
      try {
        /* 为了解决SDL色温范围欧洲保持2700-6500 */
        let areaControlWarn = this.$store.state.staticConfig.AreaControl.ColorWarn
        let Version = this.$store.state.areaControlConfig ? 'CN' : 'EU'
        areaControlWarn = areaControlWarn.filter(item => item.DataCenter.indexOf(Version) !== -1)
        minColorWarm = this.$store.state.colorTemperatureRange.Min // areaControlWarn[0].Min
        maxColorWarm = this.$store.state.colorTemperatureRange.Max // areaControlWarn[0].Max
      } catch (error) {
        minColorWarm = this.$store.state.colorTemperatureRange.Min // this.$store.state.areaControlConfig ? 1800 : 2700
        maxColorWarm = this.$store.state.colorTemperatureRange.Max // this.$store.state.areaControlConfig ? 12000 : 6500
      }
      minValue = this.$store.state.staticConfig.AbilityConfig.DefaultValue.GeneralControl['0x03130000'].Value.minValue
      // this.list = getList(this.$t, this.isdevice).map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
      // this.list = getList(this.$t, this.isdevice).map(el => { el.orderId = getSortOrderValue(el.orderType, !this.isdevice) || 1; return el }).sort((el, next) => next.orderId - el.orderId)
      this.addSceneOnList() //保利项目增加感应模式和情景号
    },

    /* 点击灯开关
     */
    buttonClick(item, index) {
      if (index == 1) {
        // 关灯
        this.doOpenLight(item)
      } else {
        this.doCloseLight(item)
      }
      this.actiove = index
    },
    /* 关闭灯
     */
    doCloseLight(item) {
      let para = {
        gpNo: this.highid,
        ChannelId: item.ChannelId,
      }
      CloseLight(para, this.functionDoNotice)
      para = null
    },
    /* 打开灯
     */
    doOpenLight(item) {
      let para = {
        gpNo: this.highid,
        ChannelId: item.ChannelId,
      }
      OpenLight(para, this.functionDoNotice)
      para = null
    },
    /* 统一控制参与方法 根据type来区分
     * _type 类型
     * _index 序号
     */
    doIsjoined(item) {
      let _type = item.MsgType
      const _index = item.ischeck

      if (this.isdevice) {
        if (_type == '0x03DA00000x03840000') {
          _type = ['0x03D80000', '0x03DA0000', '0x03840000']
        } else if (_type == '0x03880000') {
          _type = ['0x03880000']
        }
        this.$emit('Isjoined', [_type, _index])
      }
    },
    /* 统一控制处理方法 根据type来区分
     * _type 类型
     * _index 序号
     */
    doChange(item, deviceInfo, _index, isColor) {
      if (this.areaControlType === 'IFttt') return

      console.log('doChange', item, deviceInfo, _index, isColor)
      const _type = item.MsgType
      if (this.doChangeTime != null) {
        clearTimeout(this.doChangeTime)
      }
      this.doChangeTime = setTimeout(this.doChangeIn, 500, item, _type, _index, isColor)
    },
    /* 统一控制处理方法 根据type来区分
     * _type 类型
     * _index 序号
     */
    doChangeIn(item, _type, _index, isColor) {
      if (this.isdevice) {
        if (isColor && _index.indexOf('rgb') != -1) {
          _index = _index.colorHex()
        }
        this.$emit('Issued', [_type, _index])
      } else if (_type == '0x03130000') {
        this.doAdjustBright(item, _index)
      } else if (_type == '0x03110000') {
        this.buttonClick(item, _index)
      } else if (_type == '0x06') {
        //保利开关 感应模式
        this.doAdjustSenceMode(_index)
      } else if (_type == '0x05880000') {
        //情景号
        this.checkAreaMap(_index)
      }
    },
    /* 统一控制 接口数据返回方法
     * rs 接口返回数据包
     */
    functionDoNotice(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 调节亮度
     */
    doAdjustBright(item, _index) {
      // 调节亮度
      let para = {
        gpNo: this.highid,
        bright: transLightToValue(_index, 255),
        ChannelId: item.ChannelId,
      }
      AdjustBright(para, this.functionDoNotice)
      para = null
    },
    /**
     * 调节感应模式
     */
    doAdjustSenceMode(_index) {
      let para = { gpNo: this.highid, mode: _index }
      LightMode(para, this.functionDoNotice)
      para = null
    },
    async checkAreaMap(index) {
      try {
        const res = await IsExistAreaAndAddressMap({ gpNo: this.highid })
        if (res.StatusCode == this.$store.state.rightStatusCode) {
          if (res.Result) {
            const sceneRes = await GetCallScene({ gpNo: this.highid, SceneId: index })
            if (sceneRes.StatusCode == this.$store.state.rightStatusCode) {
              alertsuccess(this, sceneRes.StatusCode)
            }
          } else {
            this.$emit('showAreaMapTiop', !res.Result)
          }
        }
      } catch (error) {
        console.error('An error occurred in checkAreaMap:', error)
      }
    },
  },
}
</script>

<style scoped="scoped" lang="scss">
@import '~@/assets/css/action.scss';
.scenceMsg {
  .sevice_slider {
    width: calc(100% - 270px) !important;
  }

  .joinTool {
    /*width: 120px;*/
    margin: 0;
    display: inline-block;
  }
}
.scence_box {
  margin-top: 10px;
}
.all_set .scence_box .device_div_collapse {
  width: 100% !important;
}
.box_reset_size {
  height: 44vh;
}
.box_reset_size .device_div .scence_ctr {
  height: 20px;
  line-height: 20px;
}
.areacotrol_masker {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999999999;
}
.device_div_action {
  position: relative;
  margin-top: 20px;
  ::v-deep .common_active_div {
    height: 40px;
    align-items: center;
  }
}
.ControlName {
  width: 100%;
  position: absolute;
  top: -32px;
  margin-left: 8px;
  padding-right: 10px;
  color: #3d3d3d;
  font-weight: 500;
}
.ControlName::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 45px;
  width: calc(200% - 45px);
  height: 1px;
  background-color: #ccc;
}
.group_title {
  position: absolute;
  width: 100%;
  line-height: normal;
}
.group_title::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 45px;
  width: calc(100% - 65px);
  height: 1px;
  background-color: #ccc;
}
.group_box {
  position: relative;
  padding-left: 20px;
  width: 100%;

  &.flex_mode {
    display: flex;
  }
}
</style>
